/**
 * The top bar below 1024px: the logo and page title, then search, the bell
 * and the avatar. Light, frosted, sticky. The tab bar does the navigating.
 */

import { Search } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";

import { LogoMark } from "@/components/brand/LogoMark";
import { useAuth } from "@/hooks/useAuth";
import { openCommandPalette } from "@/lib/commandPalette";
import { ROUTES } from "@/types/routes";
import { useTenant } from "@/lib/tenant";

import { AccountMenu } from "./AccountMenu";
import { titleFor } from "./nav";
import { NotificationsButton } from "./Notifications";

export function TopBar() {
  const { displayName } = useTenant();
  const { user } = useAuth();
  const { pathname } = useLocation();

  return (
    <header className="fr-bar">
      <NavLink to={ROUTES.DASHBOARD} className="fr-bar__brand" aria-label={`${displayName}, dashboard`}>
        <LogoMark size={28} variant="gradient" />
      </NavLink>
      <span className="fr-bar__title">{titleFor(pathname, user?.role)}</span>
      <span className="fr-bar__spacer" />
      <button type="button" className="fr-icon-btn" aria-label="Search" onClick={openCommandPalette}>
        <Search size={20} strokeWidth={1.6} />
      </button>
      <NotificationsButton variant="bar" />
      <AccountMenu variant="bar" />
    </header>
  );
}
